var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-footer",
    { staticClass: "footer-color", attrs: { padless: "" } },
    [
      _c(
        "v-col",
        { staticClass: "text-center caption", attrs: { cols: "12" } },
        [
          _vm._v("\n        | "),
          _vm._l(_vm.$t("view.footer"), function(footer_link) {
            return _c(
              "a",
              {
                key: footer_link.title,
                staticClass: "white--text footer-link",
                attrs: { href: footer_link.link }
              },
              [_vm._v(_vm._s(footer_link.title) + " | ")]
            )
          }),
          _c("br"),
          _vm._v("\n\n        " + _vm._s(_vm.copyRight) + "\n    ")
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a9563b06", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a9563b06","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/globals/AppFooter.vue
// module id = jNLR
// module chunks = 1